import { Locale } from '@synergy/models';

import { Contact } from '../../../common/models/contact';

interface UserData {
    id?: number;
    email?: string;
    locale: Locale;
    isActivated: boolean;
    roles: string[];
}

export interface LoginUser extends Contact {
    user: UserData;
    perOrderOrderCeiling?: number | null;
    monthlyOrderCeiling?: number | null;
    /** What the person ordered this month for this company, net (#2283). */
    currentMonthlyOrderSum?: number | null;
}

export const isLoginUser = (user?: Contact | LoginUser): user is LoginUser => !!(user as LoginUser)?.user;
